import type { ReactElement, VoidFunctionComponent } from 'react';
import * as moment from 'moment';
import { useSelector } from 'react-redux';
import type { Project, ProjectsSort } from '../../../../../../shared/projectsV2';
import { isSortSelected, ProjectSortPrefixes } from '../../../../../../shared/projectsV2';
import * as ProjectV2Store from '../../../../../redux/projectsV2';
import Tooltip from '../../../../generic/Tooltip';
import FromNow from '../../../../generic/FromNow';
import { Icon, icons } from '../../../../generic';

type Props = {
  project: Project;
};

const RevisionTimes: VoidFunctionComponent<Props> = ({ project }: Props) => {
  const sort: ProjectsSort = useSelector(ProjectV2Store.selectors.getSort);
  const sortField =
    isSortSelected(sort, ProjectSortPrefixes.LatestScan) || !isSortSelected(sort, ProjectSortPrefixes.LastAnalyzed)
      ? 'scanned'
      : 'lastAnalyzed';
  const sortName =
    isSortSelected(sort, ProjectSortPrefixes.LatestScan) || !isSortSelected(sort, ProjectSortPrefixes.LastAnalyzed)
      ? 'scanned'
      : 'analyzed';

  const scannedOrAnalyzed: string | ReactElement = project[sortField]
    ? <FromNow date={project[sortField]} />
    : (
      <>
        <Icon icon={icons.circleO} hasSpin />
        <span className="margin-left-xs">
          {`Waiting to be ${sortName}...`}
        </span>
      </>);

  const scannedOrAnalyzedTooltipText: string = project[sortField]
    ? moment(project[sortField]).format('MMM Do, YYYY [at] HH:mm:ss')
    : `Project has not been ${sortName} yet.`;

  return (
    <div>
      <Tooltip id="project-item-tooltip" tooltip={scannedOrAnalyzedTooltipText}>
        <span className="project-item__scanned">
          {scannedOrAnalyzed}
        </span>
      </Tooltip>
    </div>
  );
};

export default RevisionTimes;
